import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';
import Block from '@components/Layout/Block';

//
//
// Extra styles added to Block Component
//
export const FooterInner = styled.div`
  // forked from Block and BlockInner in @components/Layout/Block
  padding: 0 ${space('marginMobile')} ${space('x6')} ${space('marginMobile')};

  @media screen and (${query.atLeast('tablet')}) {
    padding: 0 ${space('marginTablet')} ${space('x6')} ${space('marginTablet')};
  }

  @media screen and (${query.atLeast('desktop')}) {
    padding: 0 ${space('margin')} ${space('x10')} ${space('margin')};
  }

  @media screen and (${query.atLeast('max')}) {
    padding-top: 0;
    padding-left: calc(${space('margin')} + max(0px, 50% - 1440px / 2));
    padding-right: calc(${space('margin')} + max(0px, 50% - 1440px / 2));
    display: grid;
    grid-template-columns: 300px auto;
    grid-template-rows: auto 1fr;
    grid-column-gap: ${space('x14')};
  }

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${color('gray2')};
    margin-top: -1px;
    margin-bottom: ${space('x6')};
    grid-column: 1 / -1;

    @media screen and (${query.atLeast('desktop')}) {
      margin-bottom: ${space('x10')};
    }
  }
`;

//
//
// Child Elements under Block
//
export const StyledTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${space('x10')};

  @media screen and (${query.atLeast('desktop')}) {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  @media screen and (${query.atLeast('max')}) {
    flex-direction: column;
    flex-wrap: wrap;
  }
`;

export const StyledColumnContainer = styled.div`
  display: none;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: ${space('xl')};
  grid-row-gap: ${space('x10')};
  padding-bottom: ${space('x10')};

  @media screen and (${query.atLeast('desktop')}) {
    display: grid;
  }
`;

export const StyledLegal = styled.div`
  display: block;
  padding-bottom: ${space('x7')};

  // overrides to default RichText Styles possible
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: ${font('headline-xxs')};
    color: ${color('fg')};
    line-height: 1.2;
    letter-spacing: -0.18px;
  }
  p,
  a,
  ul,
  ol,
  li::marker {
    font-size: ${font('body-xs-light')};
    color: ${color('gray4')};
    line-height: 1.2;
    letter-spacing: -0.18px;
  }
  ul,
  ol {
    padding-left: ${space('lg')};
  }
  ul {
    list-style-type: disc;
    li::before {
      content: none;
    }
  }
  hr {
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-width: 1px 0 0 0;
    border-color: ${color('gray1')};
  }
  img {
    max-width: 100%;
    height: auto;
  }
`;

//
//
// Top Container
//
export const SocialWrapper = styled.div`
  svg {
    width: ${space('lg')};
    height: ${space('lg')}; //Special sizing

    @media screen and (${query.atLeast('desktop')}) {
      width: ${space('xl')};
      height: ${space('xl')};
    }
  }

  a {
    @media screen and (${query.atLeast('desktop')}) {
      margin-right: ${space('sm')};
    }
  }
`;

export const CompanyInformationWrapper = styled.div`
  margin-bottom: ${space('x5')};
`;

export const AddressInformationWrapper = styled.div`
  padding-bottom: 0.5rem;
`;

export const AdditionalInformationWrapper = styled.div`
  div:last-child {
    p {
      padding-bottom: 1.5rem;
    }
  }
`;

export const LogoSizer = styled.div`
  display: block;
  width: 220px;
  padding-bottom: 2.5rem;
  @media screen and (${query.atLeast('desktop')}) {
    width: 216px;
    padding-bottom: 2.5rem;
  }
`;

//
//
// Column Desktop and Mobile
//
export const StyledMiddleContainer = styled.div`
  @media screen and (${query.atLeast('max')}) {
    grid-row: span 2;
  }
`;

export const StyledDesktopContainer = styled.div`
  @media screen and (${query.below('desktop')}) {
    display: none;
  }
`;

export const StyledMobile = styled.div`
  padding-bottom: ${space('x10')};
  @media screen and (${query.atLeast('desktop')}) {
    display: none;
  }
`;

export const StyledRegular = styled.p`
  ${font('subhead-sm')};
  color: ${color('fg')};
  display: block;
  padding-bottom: 0.25rem;
  cursor: default;
  text-decoration: none;
  font-weight: 400;
`;

//
//
// Link Stylings
//
export const StyledBold = styled.p`
  ${font('subhead-sm')};
  color: ${color('fg')};
  display: block;
  padding-bottom: 0.25rem;
  cursor: default;
  text-decoration: none;
`;

export const StyledLink = styled.div`
  // this is ready to be turned into a link if needed
  display: block;
  ${font('subhead-sm')};
  color: ${color('fg')};
  // cursor: pointer;
  // text-decoration: none;

  // &:hover {
  //   text-decoration: underline;
  // }

  // &:visited {
  //   color: ${color('fg')};
  // }
`;

export const StyledRegularLinkItem = styled.div``;
export const StyledRegularLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${space('sm')};
  ${font('body-sm-light')};
  padding-bottom: calc(${space('lg')} - 6px);
  color: ${color('fg')};
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledText = styled.p`
  display: inline-flex;
  align-items: center;
  gap: ${space('sm')};
  ${font('body-sm-light')};
  padding-bottom: calc(${space('lg')} - 6px);
  color: ${color('fg')};
`;

export const StyledCity = styled(StyledLink)`
  ${font('subhead-lg')};
`;

//
//
// Footer Pattern
//
export const PatternWrapper = styled.div`
  width: 100%;
  height: 255px;
  margin-bottom: -0.5rem;

  svg {
    margin-bottom: -0.5rem;
  }
`;
